import { ref, watch } from 'vue'

function useAutofix(refToAutofix, fixer) {
  const enabled = ref(true)
  const stop = watch(refToAutofix, () => {
    if (enabled.value) {
      const fixed = fixer(refToAutofix.value)
      if (fixed !== refToAutofix.value) {
        refToAutofix.value = fixed
      }
    }
  }, { immediate: true })

  return {
    enabled,
    stop,
    autofixed: refToAutofix,
  }
}

export default useAutofix
